export interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  readCount: number;
  commentCount: number;
  imageUrl: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  content: string;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度八小时，粉丝集体破防',
    excerpt: '据知情人透露，该男星与一名神秘女子在某五星级酒店共处长达八小时，期间房间灯光始终亮着。该男星此前一直以单身人设示人，此次事件引发粉丝大规模脱粉。',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    author: '吃瓜群众小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Casual%20Asian%20young%20man%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression%2C%20neutral%20colors&width=80&height=80&seq=avatar-wang-01&orientation=squarish',
    date: '2026-07-06',
    readCount: 128000,
    commentCount: 3420,
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20dim%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20suspenseful%20mood%2C%20high%20end%20interior%2C%20no%20people%20visible%2C%20subtle%20color%20grading&width=600&height=400&seq=article-01&orientation=landscape',
    isHot: true,
    isNew: false,
    tags: ['顶流塌房', '恋情曝光', '酒店密会'],
    content: '',
  },
  {
    id: 2,
    title: '知名女网红直播间翻车，素颜出镜与精修图判若两人，弹幕炸了',
    excerpt: '该网红在某次直播中不慎关掉了美颜滤镜，真实面貌与平时发布的精修照片差距巨大，直播间弹幕瞬间沸腾，相关话题迅速登上热搜榜。',
    category: '网红八卦',
    categorySlug: 'wanghong-bagua',
    author: '深夜吃瓜人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Casual%20Asian%20young%20woman%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression%2C%20natural%20look&width=80&height=80&seq=avatar-shenye-01&orientation=squarish',
    date: '2026-07-06',
    readCount: 96500,
    commentCount: 5600,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20setup%20with%20ring%20light%20and%20camera%20on%20desk%2C%20soft%20pink%20and%20warm%20tones%2C%20cozy%20room%20background%2C%20social%20media%20aesthetic%2C%20clean%20composition&width=600&height=400&seq=article-02&orientation=landscape',
    isHot: true,
    isNew: true,
    tags: ['网红翻车', '直播事故', '美颜滤镜'],
    content: '',
  },
  {
    id: 3,
    title: '某综艺节目录制现场爆发激烈冲突，两位嘉宾当场互撕，导演组紧急叫停',
    excerpt: '据现场观众爆料，两位知名艺人在录制过程中因观点不合发生激烈争吵，甚至险些动手。节目组工作人员紧急介入调解，录制中断近两小时。',
    category: '综艺吃瓜',
    categorySlug: 'zongyi-chigua',
    author: '综艺观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Casual%20Asian%20middle%20aged%20man%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20neutral%20expression&width=80&height=80&seq=avatar-zongyi-01&orientation=squarish',
    date: '2026-07-05',
    readCount: 143000,
    commentCount: 8900,
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20set%20with%20dramatic%20lighting%2C%20empty%20stage%20with%20spotlights%2C%20tension%20atmosphere%2C%20professional%20production%20environment%2C%20cinematic%20composition&width=600&height=400&seq=article-03&orientation=landscape',
    isHot: true,
    isNew: false,
    tags: ['综艺名场面', '嘉宾互撕', '录制事故'],
    content: '',
  },
  {
    id: 4,
    title: '某大厂高管私密聊天记录曝光，涉及不正当商业竞争，公司股价应声下跌',
    excerpt: '一份据称是某知名互联网公司高管的内部聊天记录在社交平台疯传，内容涉及对竞争对手的不正当评价和商业策略。该消息曝光后，公司股价当日下跌超过5%。',
    category: '互联网瓜',
    categorySlug: 'hulianwang-gua',
    author: '科技前线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20portrait%20avatar%2C%20simple%20lighting%2C%20clean%20background%2C%20serious%20expression%2C%20neutral%20colors&width=80&height=80&seq=avatar-tech-01&orientation=squarish',
    date: '2026-07-05',
    readCount: 87000,
    commentCount: 2100,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20smartphone%20on%20desk%20showing%20chat%20interface%2C%20dim%20ambient%20lighting%2C%20professional%20corporate%20setting%2C%20mysterious%20atmosphere%2C%20clean%20composition&width=600&height=400&seq=article-04&orientation=landscape',
    isHot: false,
    isNew: true,
    tags: ['大厂八卦', '聊天记录', '股价波动'],
    content: '',
  },
  {
    id: 5,
    title: '当红小生与经纪人深夜同返公寓，疑似恋情曝光？粉丝群炸锅',
    excerpt: '有媒体拍到某当红男演员与女经纪人深夜一同返回同一公寓，两人举止亲密。该男演员此前从未公开过恋情，此次曝光引发粉丝强烈反应。',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    author: '吃瓜一线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20curious%20expression&width=80&height=80&seq=avatar-yixian-01&orientation=squarish',
    date: '2026-07-04',
    readCount: 201000,
    commentCount: 12300,
    imageUrl: 'https://readdy.ai/api/search-image?query=Night%20apartment%20building%20entrance%20with%20warm%20street%20lighting%2C%20urban%20residential%20area%2C%20mysterious%20romantic%20atmosphere%2C%20cinematic%20night%20scene%2C%20no%20identifiable%20people&width=600&height=400&seq=article-05&orientation=landscape',
    isHot: true,
    isNew: false,
    tags: ['恋情曝光', '当红小生', '深夜同行'],
    content: '',
  },
  {
    id: 6,
    title: '知名导演被曝片场耍大牌，多次无故迟到，全剧组苦不堪言',
    excerpt: '多位剧组工作人员匿名爆料，称某知名导演在拍摄期间态度恶劣，经常无故迟到数小时，对演员和工作人员呼来喝去，导致拍摄进度严重拖延。',
    category: '影视八卦',
    categorySlug: 'yingshi-bagua',
    author: '电影圈内人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20avatar%2C%20simple%20lighting%2C%20clean%20background%2C%20professional%20expression%2C%20neutral%20colors&width=80&height=80&seq=avatar-film-01&orientation=squarish',
    date: '2026-07-04',
    readCount: 76000,
    commentCount: 4300,
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20dim%20atmospheric%20lighting%2C%20professional%20movie%20production%20environment%2C%20empty%20set%2C%20cinematic%20composition&width=600&height=400&seq=article-06&orientation=landscape',
    isHot: false,
    isNew: true,
    tags: ['导演耍大牌', '剧组爆料', '片场风波'],
    content: '',
  },
  {
    id: 7,
    title: '黑料：某选秀冠军背后金主曝光，出道名额疑内定，投票数据被质疑造假',
    excerpt: '一份详细的调查报告指出，某选秀节目冠军选手背后存在强大的资本力量支持，比赛期间的投票数据存在多处疑点，多个关键节点的票数增长曲线异常。',
    category: '黑料爆料',
    categorySlug: 'heiliao-baoliao',
    author: '深挖小能手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Investigative%20Asian%20young%20man%20portrait%20avatar%2C%20simple%20lighting%2C%20clean%20background%2C%20determined%20expression&width=80&height=80&seq=avatar-shenwa-01&orientation=squarish',
    date: '2026-07-03',
    readCount: 178000,
    commentCount: 7600,
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlights%20and%20trophy%20on%20pedestal%2C%20dramatic%20lighting%2C%20empty%20auditorium%2C%20suspenseful%20atmosphere%2C%20theatrical%20composition&width=600&height=400&seq=article-07&orientation=landscape',
    isHot: true,
    isNew: false,
    tags: ['选秀黑幕', '数据造假', '资本运作'],
    content: '',
  },
  {
    id: 8,
    title: '某短视频平台头部主播涉嫌虚假宣传被立案调查，带货金额超千万',
    excerpt: '市场监管部门接到大量消费者投诉，称某拥有千万粉丝的主播在直播带货中存在夸大宣传、虚假承诺等行为。目前相关部门已正式立案调查。',
    category: '网红八卦',
    categorySlug: 'wanghong-bagua',
    author: '消费维权站',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Serious%20Asian%20woman%20portrait%20avatar%2C%20simple%20lighting%2C%20clean%20background%2C%20professional%20expression&width=80&height=80&seq=avatar-consumer-01&orientation=squarish',
    date: '2026-07-03',
    readCount: 112000,
    commentCount: 5400,
    imageUrl: 'https://readdy.ai/api/search-image?query=E-commerce%20livestream%20setup%20with%20products%20on%20display%2C%20ring%20light%2C%20smartphone%20on%20tripod%2C%20modern%20studio%20background%2C%20professional%20product%20photography%20setup&width=600&height=400&seq=article-08&orientation=landscape',
    isHot: false,
    isNew: true,
    tags: ['直播带货', '虚假宣传', '立案调查'],
    content: '',
  },
];

export const featuredArticles = articles.filter(a => a.isHot).slice(0, 4);

export const latestArticles = articles.filter(a => a.isNew).slice(0, 3);